package mapsearch

import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val mapTileModule = module {
    singleOf(::SearchSpecStore)
    singleOf(::MapTileCache)
    singleOf(::ActiveMapTilesStore)
    singleOf(::ClusterService)
}
